var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-choices",attrs:{"data-grid":_vm.choices.length}},_vm._l((_vm.choices),function(choice,index){return _c('choice-card',{key:choice.id,attrs:{"title":choice.answer,"index":index,"disabled":_vm.isAnswerSubmitted},on:{"change":function($event){return _vm.selectAnswer(choice.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }